import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { addDisposer, types } from 'mobx-state-tree';
import { BaseLinearDisplay } from '@jbrowse/plugin-linear-genome-view';
import { ConfigurationReference } from '@jbrowse/core/configuration';
import { getContainingView } from '@jbrowse/core/util';
import { autorun } from 'mobx';
/**
 * #stateModel LinearReferenceSequenceDisplay
 * base model `BaseLinearDisplay`
 */
export function modelFactory(configSchema) {
  return types.compose('LinearReferenceSequenceDisplay', BaseLinearDisplay, types.model({
    /**
     * #property
     */
    type: types.literal('LinearReferenceSequenceDisplay'),
    /**
     * #property
     */
    configuration: ConfigurationReference(configSchema),
    /**
     * #property
     */
    showForward: true,
    /**
     * #property
     */
    showReverse: true,
    /**
     * #property
     */
    showTranslation: true
  })).views(function (self) {
    var superRenderProps = self.renderProps;
    return {
      /**
       * #method
       */
      renderProps: function renderProps() {
        var showForward = self.showForward,
          showReverse = self.showReverse,
          showTranslation = self.showTranslation;
        return _objectSpread({}, superRenderProps(), {
          rpcDriverName: self.rpcDriverName,
          config: self.configuration.renderer,
          showForward: showForward,
          showReverse: showReverse,
          showTranslation: showTranslation
        });
      }
    };
  }).views(function (self) {
    return {
      /**
       * #method
       */
      regionCannotBeRendered: function regionCannotBeRendered() {
        var view = getContainingView(self);
        return (view === null || view === void 0 ? void 0 : view.bpPerPx) >= 1 ? 'Zoom in to see sequence' : undefined;
      } /* region */,
      /**
       * #getter
       */
      get rendererTypeName() {
        return self.configuration.renderer.type;
      }
    };
  }).actions(function (self) {
    return {
      /**
       * #action
       */
      toggleShowForward: function toggleShowForward() {
        self.showForward = !self.showForward;
      },
      /**
       * #action
       */
      toggleShowReverse: function toggleShowReverse() {
        self.showReverse = !self.showReverse;
      },
      /**
       * #action
       */
      toggleShowTranslation: function toggleShowTranslation() {
        self.showTranslation = !self.showTranslation;
      },
      afterAttach: function afterAttach() {
        addDisposer(self, autorun(function () {
          var view = getContainingView(self);
          if ((view === null || view === void 0 ? void 0 : view.bpPerPx) >= 1) {
            self.setHeight(50);
          } else {
            var showTranslation = self.showTranslation,
              showReverse = self.showReverse,
              showForward = self.showForward;
            var r1 = showReverse && showTranslation ? 60 : 0;
            var r2 = showForward && showTranslation ? 60 : 0;
            var t = r1 + r2;
            var r = showReverse ? 20 : 0;
            var s = showForward ? 20 : 0;
            self.setHeight(t + r + s);
          }
        }));
      }
    };
  }).views(function (self) {
    return {
      /**
       * #method
       */
      trackMenuItems: function trackMenuItems() {
        return [{
          label: 'Show forward',
          type: 'checkbox',
          checked: self.showForward,
          onClick: function onClick() {
            return self.toggleShowForward();
          }
        }, {
          label: 'Show reverse',
          type: 'checkbox',
          checked: self.showReverse,
          onClick: function onClick() {
            return self.toggleShowReverse();
          }
        }, {
          label: 'Show translation',
          type: 'checkbox',
          checked: self.showTranslation,
          onClick: function onClick() {
            return self.toggleShowTranslation();
          }
        }];
      }
    };
  });
}